export default "__VITE_ASSET__Bj46D9Oc__"